import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import { Loader } from "@/components/site/Loader";
import { Cursor } from "@/components/site/Cursor";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Stack } from "@/components/site/Stack";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { WifiPlanner } from "@/components/site/WifiPlanner";
import { HealthCheck } from "@/components/site/HealthCheck";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Enterprise } from "@/components/site/Enterprise";
import { Process } from "@/components/site/Process";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  const [ready, setReady] = useState(false);
  const done = useCallback(() => setReady(true), []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true, autoRaf: true });
    setLenis(lenis);
    lenis.stop();
    return () => {
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  useEffect(() => {
    if (!ready) return;
    import("@/lib/scroll").then(({ getLenis }) => getLenis()?.start());
  }, [ready]);

  return (
    <div className="App relative bg-void text-slate-100 min-h-screen" data-testid="landing-page">
      <AnimatePresence>{!ready && <Loader key="loader" onDone={done} />}</AnimatePresence>
      <Cursor />
      <div className="grain" aria-hidden />
      <Nav ready={ready} />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <Manifesto />
        <Services />
        <BeforeAfter />
        <Stack />
        <WifiPlanner />
        <Enterprise />
        <Process />
        <HealthCheck />
        <About />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
